import React, { useEffect, useState } from 'react';
import { HistoricalResultsApis } from 'hooks/apis/HistoricalResultsApis';
import { IAvailableResults } from 'interfaces/HistoricalResults/IAvailableResults';
import AvailableResultsGrid from '../AvailableResultsGrid/AvailableResultsGrid';

const AvailablePersonalResults = () => {
  const { getAvailablePersonalResults } = HistoricalResultsApis();
  const [availablePersonalResults, setAvailablePersonalResults] = useState<IAvailableResults[]>(null);
  const [apiMessage, setApiMessage] = useState<string>(null);

  useEffect(() => {
    getAvailablePersonalResults().then((data) => {
      if (!data.message) {
        setAvailablePersonalResults(data);
      } else {
        setApiMessage(data.message);
      }
    });
  }, [getAvailablePersonalResults]);

  return availablePersonalResults ? (
    <>
      {apiMessage && availablePersonalResults?.length === 0 ? apiMessage : null}
      {availablePersonalResults && availablePersonalResults?.length > 0 ? <><h2>Personal Jobs</h2><AvailableResultsGrid results={availablePersonalResults} /></> : null}
    </>
  ) : null;
};

export default AvailablePersonalResults;
